var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./DeleteWaitingListModal.js"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-0d470338!../../node_modules/vue-loader/lib/selector?type=template&index=0!./DeleteWaitingListModal.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/modals/DeleteWaitingListModal.vue
// module id = 702
// module chunks = 0